import React, { FC, useState } from 'react'
import { useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { CustomerCardType } from '@models/commerce/CustomerCardType'

import CustomerCard from './CustomerCard'

interface Props {
  cards: CustomerCardType[]
  onSelectCard: (card: CustomerCardType) => void
}

const SavedCustomerPayments: FC<Props> = ({ cards, onSelectCard }) => {
  const [selectedCard, setSelectedCard] = useState<CustomerCardType>()
  const { t } = useTranslation()
  useEffect(() => {
    setSelectedCard(cards[0])
  }, [cards.length])

  useEffect(() => {
    if (selectedCard) onSelectCard(selectedCard)
  }, [selectedCard])

  return (
    <div>
      <p className="mb-1 font-semibold text-md">{t('content.purchaser')}</p>
      <span className="text-md">{selectedCard?.address.name}</span>
      <p className="mt-3 mb-1 font-semibold text-md">{t('content.payment')}</p>

      {cards.length == 1 && <CustomerCard card={cards[0]} />}

      {cards.length > 1 &&
        cards.map((card, idx) => (
          <div className="flex" key={idx}>
            <input
              id={card.id}
              className="mr-1"
              type="radio"
              name="card"
              checked={selectedCard?.id == card.id}
              onChange={() => {
                setSelectedCard(cards[idx])
              }}
            />
            <label htmlFor={card.id}>
              <CustomerCard card={card} />
            </label>
          </div>
        ))}
    </div>
  )
}
export default SavedCustomerPayments
